exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Intro-block{width:30%;padding:1ex 1em;float:left;margin-right:1em;margin-bottom:1em;min-height:9em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./src/components/Container/Container.css
// module id = 225
// module chunks = 0